var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnimalPhd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#F5F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 15.6667V20.6667C25.6666 20.9463 25.7368 21.2214 25.8709 21.4667L30.4626 29.8667C30.6014 30.1206 30.6719 30.4062 30.6669 30.6955C30.6619 30.9848 30.5816 31.2679 30.4341 31.5167C30.2865 31.7656 30.0767 31.9718 29.8252 32.115C29.5738 32.2582 29.2894 32.3335 29.0001 32.3334H19.0001C18.7107 32.3335 18.4263 32.2582 18.1749 32.115C17.9234 31.9718 17.7136 31.7656 17.5661 31.5167C17.4185 31.2679 17.3383 30.9848 17.3333 30.6955C17.3283 30.4062 17.3987 30.1206 17.5376 29.8667L22.1292 21.4667C22.2633 21.2214 22.3335 20.9463 22.3334 20.6667V15.6667",
    stroke: "#7C3AED",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3774 26.5H28.6224",
    stroke: "#7C3AED",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0835 15.6667H26.9168",
    stroke: "#7C3AED",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimalPhd);
export default __webpack_public_path__ + "static/media/animalPhd.f2cb389d65ef49ca847dcf708b8d819f.svg";
export { ForwardRef as ReactComponent };